import { Pressable } from 'react-native';
import { useStore } from 'src/contexts/StoreContext';
import TextLato from '../../../text/text-lato/TextLato';
import Modal from '../../modal';
import { observer } from 'mobx-react-lite';
import { TestIDs } from 'src/constants/testIDs.constants';
import { style } from './ModalPhotoDrawerOrder.style';
import { DynamicModalProps } from '../DynamicModal.types';
import { useBottomSheetPhotoDrawerLogic } from '@photosi/rn-components/bottom-sheet-photo-drawer/BottomSheetPhotoDrawer.logic';

export const ModalPhotoDrawerOrder = observer(
  ({ dynamicModalVisible, type, dynamicModalLayer: { id } }: DynamicModalProps) => {
    const { i18n, dynamicModal, project, photoDrawer, bottomSheet } = useStore();

    const { dropdownOptions, onPressOption } = useBottomSheetPhotoDrawerLogic({
      dynamicModal,
      i18n,
      project,
      photoDrawer,
      bottomSheet,
    });

    return (
      <Modal
        visible={dynamicModalVisible}
        onClose={dynamicModal.closeModal}
        showHeader={false}
        style={style.modal}
        style_container={style.content}
        closeOnClickOutside={true}
        testID={TestIDs.PHOTO_DRAWER_ORDER}
        type={type}
        id={id}
      >
        {dropdownOptions.map((option, index) => {
          return (
            <Pressable
              style={style.option}
              onPress={() => {
                onPressOption(option);
                dynamicModal.closeModal();
              }}
              key={'dropdown-' + index}
            >
              <TextLato style={style.text}>{option}</TextLato>
            </Pressable>
          );
        })}
      </Modal>
    );
  },
);
